<template>
  <a class="mx-2 cursor-pointer" @click="sendEmailAgain" title="Wyślij email, który trafia do klienta">
    <img src="https://preciselab.fra1.digitaloceanspaces.com/emulex/00-images/resend.png" alt="Wyślij email ponownie">
  </a>
</template>

<script>
import COMPUTE_CLAUSES from "../../graphql/compute_clause_report.gql";

export default {
  name: "SendEmailButton",
  props: {
    id: {
      type: String,
      required: true
    }
  },
  methods: {
    async sendEmailAgain() {
      const { data } = await this.$apollo.mutate({
        mutation: COMPUTE_CLAUSES,
        variables: {
          id: this.id,
          sendEmail: true
        }
      });

      console.log(data);

      alert("Email został wysłany")
    }
  }
}
</script>

<style scoped>

</style>
